import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-cream min-h-[90vh] flex items-center py-16 px-4 md:px-8 overflow-hidden" data-id="element-321">
      <div className="max-w-6xl mx-auto w-full" data-id="element-322">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-323">
          {/* Copy Column */}
          <div className="order-2 lg:order-1 space-y-8" data-id="element-324">
            <FadeIn data-id="element-325">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy-800 leading-tight mb-4" data-id="element-326">
                Stop Ripping Off Your CPAP at 2 AM
              </h1>
              <p className="text-xl md:text-2xl text-teal-600 font-medium font-serif italic mb-8" data-id="element-327">
                A calm, step-by-step plan to get through the first 30 nights
                without quitting.
              </p>
            </FadeIn>

            <FadeIn delay={200} data-id="element-328">
              <div className="space-y-6 text-lg-body text-text-body leading-relaxed" data-id="element-329">
                <p data-id="element-330">
                  If you've ever woken up at 2:07 AM with your CPAP mask half
                  on, air hissing into your eyes, mouth dry like sandpaper… and
                  your hand already reaching to rip the whole thing off—
                </p>
                <p className="font-semibold text-navy-800" data-id="element-331">
                  You're not "bad at CPAP."
                </p>
                <p data-id="element-332">
                  You're sleeping in an unstable setup… and your brain is doing
                  the one thing it's designed to do at night: remove the threat.
                </p>
                <p data-id="element-333">
                  The reason you're stuck isn't because you haven't tried hard
                  enough. It's because the advice you're getting is backwards.
                </p>
                <div className="pl-4 border-l-4 border-teal-600 italic text-gray-600 my-6" data-id="element-334">
                  "Try another mask."
                  <br data-id="element-335" />
                  "You'll get used to it."
                  <br data-id="element-336" />
                  "Just tighten it."
                </div>
                <p data-id="element-337">
                  That advice turns your first month into a nightly experiment
                  with your sleep as the price.
                </p>
                <p className="font-medium text-navy-800" data-id="element-338">
                  CPAP Compliance Rescue is a calm, step-by-step plan built
                  specifically for men 65+ to get through the first 30 nights
                  without quitting—by fixing the few predictable problems in the
                  only order that works.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={400} data-id="element-339">
              <div className="pt-4" data-id="element-340">
                <a href="#pricing" onClick={e => {
                e.preventDefault();
                const el = document.getElementById('pricing');
                if (el) {
                  const start = window.scrollY;
                  const end = el.getBoundingClientRect().top + window.scrollY - 20;
                  const duration = 2500;
                  let startTime: number | null = null;
                  const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
                  const animate = (currentTime: number) => {
                    if (!startTime) startTime = currentTime;
                    const elapsed = currentTime - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
                    if (progress < 1) requestAnimationFrame(animate);
                  };
                  requestAnimationFrame(animate);
                }
              }} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-amber-500 rounded-lg hover:bg-amber-600 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200" data-id="element-341">
                  Get the 30-Night Stabilization Ladder
                  <ArrowRight className="ml-2 h-5 w-5" data-id="element-342" />
                </a>
                <p className="mt-3 text-sm text-gray-500" data-id="element-343">
                  Instant digital download • Secure checkout
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Image Column */}
          <div className="order-1 lg:order-2 relative" data-id="element-344">
            <FadeIn delay={300} data-id="element-345">
              <div className="relative rounded-xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-346">
                <img src="https://cdn.magicpatterns.com/uploads/ikNs4K7zcgG2UnTB7zFUdY/heylloyd-image-1770960574266.png" alt="CPAP Compliance Rescue Guide on Tablet" className="w-full h-auto object-cover" data-id="element-347" />
              </div>
              {/* Decorative element */}
              <div className="absolute -z-10 top-10 -right-10 w-full h-full bg-blue-50 rounded-xl transform rotate-3" data-id="element-348"></div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}